import { render, staticRenderFns } from "./VueGallery.vue?vue&type=template&id=42237096&"
import script from "./VueGallery.vue?vue&type=script&lang=js&"
export * from "./VueGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42237096')) {
      api.createRecord('42237096', component.options)
    } else {
      api.reload('42237096', component.options)
    }
    module.hot.accept("./VueGallery.vue?vue&type=template&id=42237096&", function () {
      api.rerender('42237096', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/vueGallery/VueGallery.vue"
export default component.exports